
// import React, { useState, useEffect, useRef } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { closeMenu, openMenu } from "../../features/menu/menuSlice";
// import Search from "../../components/Search";
// import { convertApiToNavData } from "../../helpers/convertApiToNavData";
// import PartnerApi from "../../helpers/PartnerApi";
// import { useTranslation } from "react-i18next";
// import DocProductModal from "../doc/DocProductModal";
// import UpdateIcon from "../../../src/icons-svg/update_icon.svg";

// const NavList = ({ navList, level = 0, onSelect }) => {
//   if (!navList || navList.length === 0) return null;
//   const isRoot = level === 0;

//   return (
//     <ul
//       style={{
//         paddingLeft: isRoot ? 20 : 10,
//         listStyleType: "none",
//         fontSize: "14px",
//       }}
//     >
//       {navList.map((item) => (
//         <li key={item.id} className="mb-1">
//           {isRoot && item.isHeader ? (
//             <div className="mt-2 mb-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded font-bold text-[20px] text-[#314251]">
//               {item.title}
//             </div>
//           ) : item.isHeader ? (
//             <strong className="block text-[#314251] font-semibold text-[16px]">
//               {item.title}
//             </strong>
//           ) : item.childs?.length > 0 ? (
//             <>
//               <strong className="block text-[#314251] font-semibold text-[16px]">
//                 {item.title}
//               </strong>
//               <NavList navList={item.childs} level={level + 1} onSelect={onSelect} />
//             </>
//           ) : (
//             <span
//               onClick={() => onSelect?.({ uuid: item.uuid, title: item.title })}
//               className="inline-block rounded cursor-pointer transition hover:bg-gray-100 dark:hover:bg-gray-700 font-normal hover:font-bold text-[#4C67E9] text-[14px]"
//               style={{ userSelect: "none" }}
//             >
//               {item.title}
//             </span>
//           )}
//         </li>
//       ))}
//     </ul>
//   );
// };

// const NavigationContent = (props) => {
//   const {
//     selectedProductName,
//     selectedVersionName,
//     productList,
//     loadingProducts,
//     errorProducts,
//     navData,
//     search,
//     setSearch,
//     onProductVersionChange,
//     onDocSelect,
//     onModalSubmit,
//     modalVisible,
//     setModalVisible,
//   } = props;

//   const { t } = useTranslation();

//   // Menü içerik durumu
//   const renderMenuContent = () => {
//     if (loadingProducts) {
//       return <p className="text-gray-500 text-sm italic">{t("Yükleniyor...")}</p>;
//     }

//     if (!loadingProducts && search && navData.length === 0) {
//       return <p className="text-gray-500 text-sm italic">{t("İçerik bulunamadı")}</p>;
//     }

//     if (!loadingProducts && !search && navData.length === 0) {
//       return <p className="text-gray-500 text-sm italic">{t("Henüz menü verisi yok")}</p>;
//     }

//     return <NavList navList={navData} onSelect={onDocSelect} />;
//   };

//   return (
//     <div className="flex flex-col h-full bg-[#F0F3F4] w-full max-w-[22rem] min-w-[16rem] lg:relative">
//       {/* Ürün/Versiyon Başlık */}
//       <div className="flex justify-between items-start px-4 pt-6 text-sm flex-shrink-0">
//         <div className="flex flex-wrap gap-x-4 gap-y-1 min-w-0 flex-1">
//           <div className="flex items-center">
//             <strong className="mr-1 whitespace-nowrap">{t("Ürün")}:</strong>
//             <span className="truncate">{selectedProductName || "-"}</span>
//           </div>
//           <div className="flex items-center">
//             <strong className="mr-1 whitespace-nowrap">{t("Versiyon")}:</strong>
//             <span className="truncate">{selectedVersionName || "-"}</span>
//           </div>
//         </div>
//         <button
//           onClick={() => setModalVisible(true)}
//           title={t("Ürün/Versiyon Güncelle")}
//           className="flex-shrink-0 ml-2"
//         >
//           <img src={UpdateIcon} alt="Güncelle" className="w-5 h-5 object-contain" />
//         </button>
//       </div>

//       {/* Arama Alanı */}
//       <div className="px-4 py-3 flex-shrink-0">
//         <Search
//           onSearch={setSearch}
//           placeholder={t("Ara...")}
//           value={search}
//           className="rounded px-2 py-1"
//           style={{
//             backgroundColor: "#ffffff",
//             color: "#000000",
//             border: "1px solid #C4CED8",
//           }}
//         />
//       </div>

//       {/* Menü Scroll Alanı */}
//       <div className="flex-1 overflow-y-auto px-4 pb-2">
//         {renderMenuContent()}
//       </div>

//       {/* Footer Sabit */}
//       <div className="px-4 py-2 bg-gray-200 text-gray-800 font-semibold border-t border-gray-300 flex-shrink-0 sticky bottom-0">
//         V1.0.5
//       </div>

//       {/* Ürün seçme modali */}
//       <DocProductModal
//         visible={modalVisible}
//         onClose={() => setModalVisible(false)}
//         onSubmit={onModalSubmit}
//         productList={productList}
//         loading={loadingProducts}
//         error={errorProducts}
//       />
//     </div>
//   );
// };

// const Navigation = ({ onDocSelect, onProductVersionChange, onNavDataLoaded }) => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useDispatch();
//   const { open } = useSelector((state) => state.menu);

//   const tRef = useRef(t);
//   const [search, setSearch] = useState("");
//   const [navData, setNavData] = useState([]);
//   const [product, setProduct] = useState("");
//   const [version, setVersion] = useState("");
//   const [modalVisible, setModalVisible] = useState(false);
//   const [productList, setProductList] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(false);
//   const [errorProducts, setErrorProducts] = useState(null);
//   const [selectedProductName, setSelectedProductName] = useState("");
//   const [selectedVersionName, setSelectedVersionName] = useState("");

//   const handleDocSelectInternal = (doc) => {
//     onDocSelect?.(doc);
//     dispatch(closeMenu());
//   };

// const normalizeString = (str) => {
//   if (!str) return "";
//   return str
//     .normalize("NFD")             
//     .replace(/[\u0300-\u036f]/g, "") 
//     .replace(/[’'`´]/g, "")          
//     // Türkçe
//     .replace(/ü/g, "u").replace(/Ü/g, "u")
//     .replace(/ö/g, "o").replace(/Ö/g, "o")
//     .replace(/ç/g, "c").replace(/Ç/g, "c")
//     .replace(/ş/g, "s").replace(/Ş/g, "s")
//     .replace(/ı/g, "i").replace(/İ/g, "i")
//     .replace(/ğ/g, "g").replace(/Ğ/g, "g")
//     // Fransızca & Almanca
//     .replace(/œ/g, "oe").replace(/Œ/g, "oe")
//     .replace(/æ/g, "ae").replace(/Æ/g, "ae")
//     .replace(/ß/g, "ss")
//     .replace(/ä/g, "a").replace(/Ä/g, "a")
//     .replace(/ë/g, "e").replace(/Ë/g, "e")
//     .replace(/ï/g, "i").replace(/Ï/g, "i")
//     .replace(/ÿ/g, "y").replace(/Ÿ/g, "y")
//     // Trim
//     .trim()
//     .toLowerCase();
// };

// const searchMapping = {
//   codage: "Outil WD en Caisse",
//   agenda: "Types d'actions",
// };

// const filteredDocs = docSearchList.flatMap(group =>
//   group.docList.filter(doc => {
//     const searchTerm = userInput.toLowerCase();
//     const mappedKeyword = searchMapping[searchTerm] || searchTerm;

//     const subject = doc.description.subject.toLowerCase();
//     const keyword = doc.description.keyword.toLowerCase();

//     return subject.includes(mappedKeyword.toLowerCase()) ||
//            keyword.includes(mappedKeyword.toLowerCase());
//   })
// );

// const filterNavData = (items, keyword) => {
//   const normalizedKeyword = normalizeString(keyword);
//   return items.reduce((result, item) => {
//     // Başlık eşleşmesi
//     const titleMatches = normalizeString(item.title).includes(normalizedKeyword);
    
//     // description içinden subject & keyword
//     const subjectMatches = normalizeString(item.subject || "").includes(normalizedKeyword);

//     const keywords = (item.keyword || "").split(",");
//     const keywordMatches = keywords.some(k =>
//       normalizeString(k).includes(normalizedKeyword)
//     );

//     if (titleMatches || subjectMatches || keywordMatches) {
//       result.push({ ...item });
//     } else if (item.childs?.length > 0) {
//       const filteredChilds = filterNavData(item.childs, keyword);
//       if (filteredChilds.length > 0) {
//         result.push({ ...item, childs: filteredChilds });
//       }
//     }

//     return result;
//   }, []);
// };

//   // const filterNavData = (items, keyword) => {
//   //   return items.reduce((result, item) => {
//   //     const titleMatches = item.title?.toLowerCase().includes(keyword);
//   //     if (titleMatches) result.push({ ...item });
//   //     else if (item.childs?.length > 0) {
//   //       const filteredChilds = filterNavData(item.childs, keyword);
//   //       if (filteredChilds.length > 0) result.push({ ...item, childs: filteredChilds });
//   //     }
//   //     return result;
//   //   }, []);
//   // };

//   // const fetchData = async (prod, ver) => {
//   //   if (!prod || !ver) return;

//   //   try {
//   //     const res = await PartnerApi.getDocSearchList({
//   //       product: prod,
//   //       version: ver,
//   //       language: i18n.language,
//   //       status: 2,
//   //       level: 4,
//   //     });
//   //     const converted = convertApiToNavData(res, tRef.current, i18n.language);
//   //     setNavData(converted);

//   //     // Menü yüklendiğinde MainLayout'a bildir
//   //     onNavDataLoaded?.(converted);

//   //     // İlk dokümanı otomatik seç
//   //     const first = converted.find((item) => !item.isHeader && item.uuid) || null;
//   //     if (first) handleDocSelectInternal(first);
//   //   } catch (err) {
//   //     console.error("Veri alınamadı", err);
//   //     setNavData([]);
//   //     onNavDataLoaded?.([]);
//   //   }
//   // };

//   const fetchData = async (prod, ver) => {
//   if (!prod || !ver) {
//     console.warn("[Navigation] fetchData çağrılmadı: product veya version eksik", prod, ver);
//     return;
//   }

//   console.log("[Navigation] fetchData çağrıldı");
//   console.log("Parametreler -> Product:", prod, "Version:", ver, "Language:", i18n.language);

//   try {
//     const res = await PartnerApi.getDocSearchList({
//       product: prod,
//       version: ver,
//       language: i18n.language,
//       status: 2,
//       level: 4,
//     });

//     console.log("[Navigation] API Response:", res);

//     const converted = convertApiToNavData(res, tRef.current, i18n.language);
//     console.log("[Navigation] convertApiToNavData sonucu:", converted);

//     setNavData(converted);

//     // Menü yüklendiğinde MainLayout'a bildir
//     onNavDataLoaded?.(converted);

//     // İlk dokümanı otomatik seç
//     const first = converted.find((item) => !item.isHeader && item.uuid) || null;
//     console.log("[Navigation] İlk doküman seçiliyor:", first);
//     if (first) handleDocSelectInternal(first);

//   } catch (err) {
//     console.error("[Navigation] Veri alınamadı", err);
//     setNavData([]);
//     onNavDataLoaded?.([]);
//   }
// };
//   useEffect(() => {
//     const fetchProducts = async () => {
//       setLoadingProducts(true);
//       try {
//         const res = await PartnerApi.getDocProductList();
//         setProductList(res?.docProductList ?? []);
//         setModalVisible(true);
//       } catch (err) {
//         setErrorProducts(t("Ürün listesi yüklenirken hata oluştu."));
//       } finally {
//         setLoadingProducts(false);
//       }
//     };
//     fetchProducts();
//   }, [t]);

//   useEffect(() => {
//     fetchData(product, version);
//   }, [product, version, i18n.language]);

//   const getFilteredData = () => {
//     if (!search) return navData;
//     return filterNavData(navData, search.toLowerCase());
//   };

//   const handleModalSubmit = ({ product: p, version: v, productName }) => {
//     if (p === product && v === version) {
//       setModalVisible(false);
//       return;
//     }
//     onProductVersionChange?.({ product: p, version: v, productName });
//     setProduct(p);
//     setVersion(v);
//     setSelectedProductName(productName);
//     setSelectedVersionName(v);
//     setModalVisible(false);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 1280) dispatch(closeMenu());
//       else dispatch(openMenu());
//     };
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [dispatch]);

//   return (
//     <>
//       {/* Masaüstü */}
//       <div className="hidden lg:flex flex-col h-full">
//         <NavigationContent
//           selectedProductName={selectedProductName}
//           selectedVersionName={selectedVersionName}
//           productList={productList}
//           loadingProducts={loadingProducts}
//           errorProducts={errorProducts}
//           navData={getFilteredData()}
//           search={search}
//           setSearch={setSearch}
//           onDocSelect={handleDocSelectInternal}
//           onProductVersionChange={onProductVersionChange}
//           onModalSubmit={handleModalSubmit}
//           modalVisible={modalVisible}
//           setModalVisible={setModalVisible}
//         />
//       </div>

//       {/* Mobil ve tablet cihazlar */}
//       {open && (
//         <div className="fixed inset-0 z-50 flex lg:hidden">
//           <div
//             className="fixed inset-0 bg-black bg-opacity-50"
//             onClick={() => dispatch(closeMenu())}
//           />
//           <div className="relative z-50 w-full max-w-[22rem] bg-[#F0F3F4] shadow-xl h-full">
//             <NavigationContent
//               selectedProductName={selectedProductName}
//               selectedVersionName={selectedVersionName}
//               productList={productList}
//               loadingProducts={loadingProducts}
//               errorProducts={errorProducts}
//               navData={getFilteredData()}
//               search={search}
//               setSearch={setSearch}
//               onDocSelect={handleDocSelectInternal}
//               onProductVersionChange={onProductVersionChange}
//               onModalSubmit={handleModalSubmit}
//               modalVisible={modalVisible}
//               setModalVisible={setModalVisible}
//             />
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Navigation;

import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeMenu, openMenu } from "../../features/menu/menuSlice";
import Search from "../../components/Search";
import { convertApiToNavData } from "../../helpers/convertApiToNavData";
import PartnerApi from "../../helpers/PartnerApi";
import { useTranslation } from "react-i18next";
import DocProductModal from "../doc/DocProductModal";
import UpdateIcon from "../../../src/icons-svg/update_icon.svg";

const NavList = ({ navList, level = 0, onSelect }) => {
  if (!navList || navList.length === 0) return null;
  const isRoot = level === 0;

  return (
    <ul
      style={{
        paddingLeft: isRoot ? 20 : 10,
        listStyleType: "none",
        fontSize: "14px",
      }}
    >
      {navList.map((item) => (
        <li key={item.id} className="mb-1">
          {isRoot && item.isHeader ? (
            <div className="mt-2 mb-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded font-bold text-[20px] text-[#314251]">
              {item.title}
            </div>
          ) : item.isHeader ? (
            <strong className="block text-[#314251] font-semibold text-[16px]">
              {item.title}
            </strong>
          ) : item.childs?.length > 0 ? (
            <>
              <strong className="block text-[#314251] font-semibold text-[16px]">
                {item.title}
              </strong>
              <NavList navList={item.childs} level={level + 1} onSelect={onSelect} />
            </>
          ) : (
            <span
              onClick={() => onSelect?.({ uuid: item.uuid, title: item.title })}
              className="inline-block rounded cursor-pointer transition hover:bg-gray-100 dark:hover:bg-gray-700 font-normal hover:font-bold text-[#4C67E9] text-[14px]"
              style={{ userSelect: "none" }}
            >
              {item.title}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

const NavigationContent = (props) => {
  const {
    selectedProductName,
    selectedVersionName,
    productList,
    loadingProducts,
    errorProducts,
    navData,
    search,
    setSearch,
    onDocSelect,
    onModalSubmit,
    modalVisible,
    setModalVisible,
  } = props;

  const { t } = useTranslation();

  const renderMenuContent = () => {
    if (loadingProducts) {
      return <p className="text-gray-500 text-sm italic">{t("Yükleniyor...")}</p>;
    }

    if (!loadingProducts && search && navData.length === 0) {
      return <p className="text-gray-500 text-sm italic">{t("İçerik bulunamadı")}</p>;
    }

    if (!loadingProducts && !search && navData.length === 0) {
      return <p className="text-gray-500 text-sm italic">{t("Henüz menü verisi yok")}</p>;
    }

    return <NavList navList={navData} onSelect={onDocSelect} />;
  };

  return (
    <div className="flex flex-col h-full bg-[#F0F3F4] w-full max-w-[22rem] min-w-[16rem] lg:relative">
      {/* Ürün/Versiyon Başlık */}
      <div className="flex justify-between items-start px-4 pt-6 text-sm flex-shrink-0">
        <div className="flex flex-wrap gap-x-4 gap-y-1 min-w-0 flex-1">
          <div className="flex items-center">
            <strong className="mr-1 whitespace-nowrap">{t("Ürün")}:</strong>
            <span className="truncate">{selectedProductName || "-"}</span>
          </div>
          <div className="flex items-center">
            <strong className="mr-1 whitespace-nowrap">{t("Versiyon")}:</strong>
            <span className="truncate">{selectedVersionName || "-"}</span>
          </div>
        </div>
        <button
          onClick={() => setModalVisible(true)}
          title={t("Ürün/Versiyon Güncelle")}
          className="flex-shrink-0 ml-2"
        >
          <img src={UpdateIcon} alt="Güncelle" className="w-5 h-5 object-contain" />
        </button>
      </div>

      {/* Arama Alanı */}
      <div className="px-4 py-3 flex-shrink-0">
        <Search 
          onSearch={setSearch}
          placeholder={t("Ara...")}
          value={search}
          className="rounded px-2 py-1"
          style={{
            backgroundColor: "#ffffff",
            color: "#000000",
            border: "1px solid #C4CED8",
          }}
        />
      </div>

      {/* Menü Scroll Alanı */}
      <div className="flex-1 overflow-y-auto px-4 pb-2">
        {renderMenuContent()}
      </div>

      {/* Footer Sabit */}
      <div className="px-4 py-2 bg-gray-200 text-gray-800 font-semibold border-t border-gray-300 flex-shrink-0 sticky bottom-0">
        V1.0.5
      </div>

      {/* Ürün seçme modali */}
      <DocProductModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onSubmit={onModalSubmit}
        productList={productList}
        loading={loadingProducts}
        error={errorProducts}
      />
    </div>
  );
};

const Navigation = ({ onDocSelect, onProductVersionChange, onNavDataLoaded }) => {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const { open } = useSelector((state) => state.menu);

  const tRef = useRef(t);
  const [search, setSearch] = useState("");
  const [navData, setNavData] = useState([]);
  const [product, setProduct] = useState("");
  const [version, setVersion] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [productList, setProductList] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [errorProducts, setErrorProducts] = useState(null);
  const [selectedProductName, setSelectedProductName] = useState("");
  const [selectedVersionName, setSelectedVersionName] = useState("");

  const handleDocSelectInternal = (doc) => {
    onDocSelect?.(doc);
    dispatch(closeMenu());
  };

  const normalizeString = (str) => {
    if (!str) return "";
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[’'`´]/g, "")
      .replace(/ü/g, "u").replace(/Ü/g, "u")
      .replace(/ö/g, "o").replace(/Ö/g, "o")
      .replace(/ç/g, "c").replace(/Ç/g, "c")
      .replace(/ş/g, "s").replace(/Ş/g, "s")
      .replace(/ı/g, "i").replace(/İ/g, "i")
      .replace(/ğ/g, "g").replace(/Ğ/g, "g")
      .replace(/œ/g, "oe").replace(/Œ/g, "oe")
      .replace(/æ/g, "ae").replace(/Æ/g, "ae")
      .replace(/ß/g, "ss")
      .replace(/ä/g, "a").replace(/Ä/g, "a")
      .replace(/ë/g, "e").replace(/Ë/g, "e")
      .replace(/ï/g, "i").replace(/Ï/g, "i")
      .replace(/ÿ/g, "y").replace(/Ÿ/g, "y")
      .replace(/è/g, "e").replace(/È/g, "e")
      .trim()
      .toLowerCase();
  };

  const searchMapping = {
    codage: "Outil WD en Caisse",
    agenda: "Types d'actions",
  };

const filterNavData = (items, keyword) => {
  if (!keyword) return items;

  const normalizedKeyword = normalizeString(keyword);
  const mappedKeyword = normalizeString(searchMapping[normalizedKeyword] || "");

  return items.reduce((result, item) => {
    const keywords = (item.keyword || "").split(",").map(k => normalizeString(k));

    // Hem girilen kelime hem mapping karşılığı aranacak
    const titleMatches =
      normalizeString(item.title).includes(normalizedKeyword) ||
      (mappedKeyword && normalizeString(item.title).includes(mappedKeyword));

    const subjectMatches =
      normalizeString(item.subject || "").includes(normalizedKeyword) ||
      (mappedKeyword && normalizeString(item.subject || "").includes(mappedKeyword));

    const keywordMatches =
      keywords.some(k => k.includes(normalizedKeyword)) ||
      (mappedKeyword && keywords.some(k => k.includes(mappedKeyword)));

    if (titleMatches || subjectMatches || keywordMatches) {
      result.push({ ...item });
    } else if (item.childs?.length > 0) {
      const filteredChilds = filterNavData(item.childs, keyword);
      if (filteredChilds.length > 0) {
        result.push({ ...item, childs: filteredChilds });
      }
    }
    return result;
  }, []);
};

  const fetchData = async (prod, ver) => {
    if (!prod || !ver) return;
    try {
      const res = await PartnerApi.getDocSearchList({
        product: prod,
        version: ver,
        language: i18n.language,
        status: 2,
        level: 4,
      });

      const converted = convertApiToNavData(res, tRef.current, i18n.language);
      setNavData(converted);
      onNavDataLoaded?.(converted);

      const first = converted.find((item) => !item.isHeader && item.uuid) || null;
      if (first) handleDocSelectInternal(first);
    } catch (err) {
      console.error("Veri alınamadı", err);
      setNavData([]);
      onNavDataLoaded?.([]);
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      setLoadingProducts(true);
      try {
        const res = await PartnerApi.getDocProductList();
        setProductList(res?.docProductList ?? []);
        setModalVisible(true);
      } catch (err) {
        setErrorProducts(t("Ürün listesi yüklenirken hata oluştu."));
      } finally {
        setLoadingProducts(false);
      }
    };
    fetchProducts();
  }, [t]);

  useEffect(() => {
    fetchData(product, version);
  }, [product, version, i18n.language]);

  const getFilteredData = () => filterNavData(navData, search);

  const handleModalSubmit = ({ product: p, version: v, productName }) => {
    if (p === product && v === version) {
      setModalVisible(false);
      return;
    }
    onProductVersionChange?.({ product: p, version: v, productName });
    setProduct(p);
    setVersion(v);
    setSelectedProductName(productName);
    setSelectedVersionName(v);
    setModalVisible(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1280) dispatch(closeMenu());
      else dispatch(openMenu());
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  return (
    <>
      <div className="hidden lg:flex flex-col h-full">
        <NavigationContent
          selectedProductName={selectedProductName}
          selectedVersionName={selectedVersionName}
          productList={productList}
          loadingProducts={loadingProducts}
          errorProducts={errorProducts}
          navData={getFilteredData()}
          search={search}
          setSearch={setSearch}
          onDocSelect={handleDocSelectInternal}
          onProductVersionChange={onProductVersionChange}
          onModalSubmit={handleModalSubmit}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
      </div>

      {open && (
        <div className="fixed inset-0 z-50 flex lg:hidden">
          <div
            className="fixed inset-0 bg-black bg-opacity-50"
            onClick={() => dispatch(closeMenu())}
          />
          <div className="relative z-50 w-full max-w-[22rem] bg-[#F0F3F4] shadow-xl h-full">
            <NavigationContent
              selectedProductName={selectedProductName}
              selectedVersionName={selectedVersionName}
              productList={productList}
              loadingProducts={loadingProducts}
              errorProducts={errorProducts}
              navData={getFilteredData()}
              search={search}
              setSearch={setSearch}
              onDocSelect={handleDocSelectInternal}
              onProductVersionChange={onProductVersionChange}
              onModalSubmit={handleModalSubmit}
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Navigation;












